export default rawRG => {
  if (rawRG)
    return rawRG.replace(/(\d{2})(\d{3})(\d{3})(\d{1})/g, "$1.$2.$3-$4");
  return "";
};
